module.exports = __webpack_public_path__ + "static/media/tada_terms_zh-TW_HK.8bcc35bd.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/tada_terms_zh-TW_HK.md
// module id = 105
// module chunks = 0